import { render, staticRenderFns } from "./EnabledShippingMethod.vue?vue&type=template&id=65d31c42&"
import script from "./EnabledShippingMethod.vue?vue&type=script&lang=js&"
export * from "./EnabledShippingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports